/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {prepareSparkPayment} from '../api'

export const useMutationPrepareSparkPayment = createReactQueryMutationHook('prepareSparkPayment', prepareSparkPayment)
